import { render, staticRenderFns } from "./AddConsultantPaymentForm.vue?vue&type=template&id=7b1ab92a&"
import script from "./AddConsultantPaymentForm.vue?vue&type=script&lang=ts&"
export * from "./AddConsultantPaymentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports